import { queryConstitutiveData } from '@/api/influx/influx';
import EChartsReact from 'echarts-for-react';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import LinePointChart from './line-point-chart';
import './index.less'
import { Transfer2DisplayScale } from '@/global/utils/unit-type';

interface LoadDisplacement {
    projectId: number
    load: number[],
    displacement: number[]
}

interface Iprops {
    points: number[][]
    t2: number
    t3: number
    t4: number
    xUnit: string
    yUnit: string
}
export default function LoadDisplacementChart(props: Iprops) {

    const { projectId } = useParams();

    const [baseData, setBaseData] = useState<number[][]>([]);

    useEffect(() => {
        if (isNaN(+projectId)) return;
        generateBaseData(+projectId)
    }, [projectId])

    const generateBaseData = (projectId: number) => {
        queryConstitutiveData(projectId).then(res => {
            let loadDisplacement: LoadDisplacement = res.data;
            if (loadDisplacement == null || loadDisplacement.load == null) return;
            let curveData = [];
            for (let idx = 0; idx < loadDisplacement.load.length; idx++) {
                if (loadDisplacement.displacement.length <= idx) break;
                const y = (loadDisplacement.load[idx] * Transfer2DisplayScale(props.yUnit)).toFixed(2);
                const x = (loadDisplacement.displacement[idx] * Transfer2DisplayScale(props.xUnit)).toFixed(1);
                curveData.push([x, y]);
            }
            setBaseData(curveData);
        })
    }



    return (
        <div className='load-disp-panel'>
            <LinePointChart
                lineData={baseData}
                title="荷载位移曲线"
                tooltipXLabel={`位移 ${props.xUnit || ''}`}
                tooltipYLabel={`风压 ${props.yUnit || ''}`}
                t2={[props.t2, props.t3]}
                t3={[props.t3, props.t4]}
                t4={[(props.t4 == 0 || props.t4 == null) ? Number.MAX_VALUE : props.t4, Number.MAX_VALUE]}
                points={props.points || []}
            />
        </div>
    )
}
